<template>
  <div>
    <DashboardHeader title="Capture Marks">
      <v-layout row wrap>
        <v-flex xs12 md2 v-if="isAdmin">
          <v-card
            :color="getThemeColor"
            dark
            class="mx-2 mt-2 px-4 py-0"
            shaped
            elevation="12"
            max-width="344"
            outlined
            v-for="(label,lKey) in labels"
            :key="lKey+Math.random()"
          >
            <v-text-field
              :ref="'label-'+label.key"
              :value="label.title"
              :label="label.title"
              @blur="getStreamLabel()"
              class="my-0"
            ></v-text-field>
            <v-layout row wrap>
              <v-flex xs12 md12 class="ml-2 mt-0 mb-4">
                <span style="font-size:12px">Total: &nbsp;</span>
                <span
                  :ref="'assess-'+label.key"
                  class="px-4"
                  contenteditable
                  style="border-bottom:solid 1px white;font-size:12px"
                >{{weightings[label.key] | getAssessmentTotal }}</span>
                <br />
                <span style="font-size:12px;display:inline-block;float:left">Weight: &nbsp;</span>
                <span
                  :ref="'weight-'+label.key"
                  class="px-4"
                  contenteditable
                  style="border-bottom:solid 1px white;font-size:12px;display:inline-block;float:left"
                >{{ weightings[label.key] | getAssessmentWeight}}</span>

                <small class="ml-6">
                  <v-icon @click="openStreamLabelDialog(label.key)" color="green">mdi-check</v-icon>
                  <v-icon @click="deleteWeighting(weightings[label.key])" color="red">mdi-close</v-icon>
                </small>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex xs12 md10 class="mt-4" style="margin:0px" v-if="isStaff">
          <v-card>
            <v-row class="mt-6">
              <span class="mx-6">Class: {{selectedClass}}</span>
              <span class="mx-6">Year: {{reportYear}}</span>
              <span
                class="mx-6"
                v-if="selectedReportTerm"
              >Term: {{selectedReportTerm.toUpperCase()}}</span>
              <span class="mx-6" v-if="subject.title">Subject: {{subject.title.toUpperCase()}}</span>

              <v-spacer></v-spacer>
              <v-text-field
                class="mt-0 mx-6 mb-6"
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                style="display:inline"
              ></v-text-field>
            </v-row>

            <v-data-table :headers="headers" :items="assessments" :search="search">
              <template v-slot:item.profile="{item}">
                <v-icon :color="getThemeColor" @click="viewProfile(item)">mdi-account-circle</v-icon>
              </template>
              <template v-slot:item.assessment_1="{item}">
                <v-text-field
                  @change="updateField(item.id,'assessment_1',item)"
                  v-model="item.assessment_1"
                ></v-text-field>
                <span>Weight: {{ convertToWeight(item.assessment_1,'assessment_1') }}</span>
              </template>
              <template v-slot:item.assessment_2="{item}">
                <v-text-field
                  @change="updateField(item.id,'assessment_2',item)"
                  v-model="item.assessment_2"
                ></v-text-field>
                <span>Weight: {{ convertToWeight(item.assessment_2,'assessment_2') }}</span>
              </template>
              <template v-slot:item.assessment_3="{item}">
                <v-text-field
                  @change="updateField(item.id,'assessment_3',item)"
                  v-model="item.assessment_3"
                ></v-text-field>
                <span>Weight: {{ convertToWeight(item.assessment_3,'assessment_3')}}</span>
              </template>
              <template v-slot:item.assessment_4="{item}">
                <v-text-field
                  @change="updateField(item.id,'assessment_4',item)"
                  v-model="item.assessment_4"
                ></v-text-field>
                <span>Weight: {{ convertToWeight(item.assessment_4,'assessment_4')}}</span>
              </template>
              <template v-slot:item.assessment_5="{item}">
                <v-text-field
                  @change="updateField(item.id,'assessment_5',item)"
                  v-model="item.assessment_5"
                ></v-text-field>
                <span>Weight: {{ convertToWeight(item.assessment_5,'assessment_5')}}</span>
              </template>
              <template v-slot:item.assessment_6="{item}">
                <v-text-field
                  @change="updateField(item.id,'assessment_6',item)"
                  v-model="item.assessment_6"
                ></v-text-field>
                <span>Weight: {{ convertToWeight(item.assessment_6,'assessment_6')}}</span>
              </template>
              <template v-slot:item.assessment_7="{item}">
                <v-text-field
                  @change="updateField(item.id,'assessment_7',item)"
                  v-model="item.assessment_7"
                ></v-text-field>
                <span>Weight: {{ convertToWeight(item.assessment_7,'assessment_7')}}</span>
              </template>
              <template v-slot:item.sub_8="{item}">
                <v-text-field @change="updateField(item.id,'sub_8',item)" v-model="item.sub_8"></v-text-field>
              </template>
              <template v-slot:item.sub_9="{item}">
                <v-text-field @change="updateField(item.id,'sub_9',item)" v-model="item.sub_9"></v-text-field>
              </template>
              <template v-slot:item.sub_10="{item}">
                <v-text-field @change="updateField(item.id,'sub_10',item)" v-model="item.sub_10"></v-text-field>
              </template>
              <template v-slot:item.sub_11="{item}">
                <v-text-field @change="updateField(item.id,'sub_11',item)" v-model="item.sub_11"></v-text-field>
              </template>
              <template v-slot:item.sub_12="{item}">
                <v-text-field @change="updateField(item.id,'sub_12',item)" v-model="item.sub_12"></v-text-field>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
      <v-dialog v-model="dialog" width="800" persistent>
        <v-card v-if="applytoOthers">
          <v-card-title
            :style="{'background-color':getThemeColor,'color':'white'}"
            class="headline lighten-2 mb-6"
          >Apply Subject Label To Other Classess</v-card-title>

          <span class="my-12 ml-6 title">Assessment {{streamColumn.split('_')[1]}} =></span>
          <span class="mb-12 mx-4 title">To Be Labelled As: " {{streamLabel}} " For Selected Classes</span>
          <br />
          <span class="mb-12 mx-4 title">Assessment Total: " {{assessmentTotal}} "</span>
          <br />
          <span class="mb-12 mx-4 title">Converted To Weight: " {{convertedWeight}} " Out of 100%</span>
          <br />
          <v-layout row wrap class="mx-2 mt-6">
            <v-flex xs4 md4 v-for="(cls,inc) in classes" :key="inc+Math.random()">
              <v-card width="200" class="ml-4 mb-2 pl-4" :color="getThemeColor" shaped dark>
                <v-checkbox class="shrink" :value="cls.class_name" v-model="selectedClasses"></v-checkbox>
                <span>{{cls.class_name}}</span>
              </v-card>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded color="red" dark @click="closeDialog()">Cancel</v-btn>
            <v-btn rounded color="success" dark @click="saveWeightings()">Apply Now</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </DashboardHeader>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import DashboardHeader from "@/components/DashboardHeader.vue";

export default {
  components: {
    DashboardHeader
  },
  computed: {
    getMarksScheduleParams() {
      return this.$store.getters.getMarksScheduleParams;
    },
    isManager() {
      return this.$store.getters.isManager;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isStaff() {
      return this.$store.getters.isStaff;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },

    getUserSchool() {
      return this.$store.getters.getUserSchool;
    },
    isDisabled: function() {
      return !this.saveChanges;
    }
  },
  mounted() {
    this.students = this.getMarksScheduleParams.selectedStudents;
    this.reportYear = this.getMarksScheduleParams.reportYear;
    this.selectedReportTerm = this.getMarksScheduleParams.selectedReportTerm;
    this.dsc = this.getMarksScheduleParams.dsc;
    this.dsrop = this.getMarksScheduleParams.dsrop;
    this.selectedClass = this.getMarksScheduleParams.selectedClass;
    this.subject = this.$route.params.subject;
    this.classes = this.$route.params.classes;
    this.$store.commit("setLoader", true);

    axios
      .postDataWithToken(
        "/auth/initialise-assessments-table",
        {
          selectedStudents: this.students,
          reportYear: this.reportYear,
          selectedReportTerm: this.selectedReportTerm,
          selectedClass: this.selectedClass,
          subject: this.subject.key
        },
        this.getAccessToken
      )
      .then(assessments => {
        this.assessments = assessments;
        axios
          .postDataWithToken(
            "/auth/get-or-set-assessment-labels-for-selected-subject",
            {
              selectedStudents: this.students,
              reportYear: this.reportYear,
              selectedReportTerm: this.selectedReportTerm,
              selectedClass: this.selectedClass,
              subject: this.subject.key
            },
            this.getAccessToken
          )
          .then(label => {
            this.refreshLabel(label);
          });
      });
  },
  data: () => ({
    weightings: {},
    saveChanges: false,
    studentID: null,
    applytoOthers: false,
    classes: [],
    selectedClasses: [],
    streamLabels: [],
    streamLabel: null,
    streamColumn: null,
    assessmentTotal: 0,
    convertedWeight: 0,
    labels: [],
    subject: { title: "", key: "" },
    labelObj: null,
    assessments: [],
    marks: [],
    messageCredit: null,
    selectedDate: new Date().toISOString().substr(0, 10),
    schoolEmis: null,
    classPromotedTo: null,
    datePicker: new Date().toISOString().substr(0, 10),
    reportYear: new Date().getFullYear(),
    dialog: false,
    feeIDs: [],
    selectedReportTerm: null,
    dsc: null,
    dsrop: null,
    selectAll: false,
    selectedClass: null,
    selectedTerm: null,
    snackbarColor: "",
    snackbarModel: false,

    students: [],
    nameRules: [v => !!v || "Field is required"],
    showActionButtons: false,
    search: null,
    selectedStudents: [],
    allSelected: [],
    headStart: [
      { text: "Profile", value: "profile" },
      {
        text: "SID",
        align: "start",
        value: "sid"
      },
      { text: "Surname", value: "student.lname" },
      { text: "First Names", value: "student.fname" }
    ],
    headers: [],
    terms: [
      { text: "Term 1", value: "term1" },
      { text: "Term 2", value: "term2" },
      { text: "Term 3", value: "term3" },
      { text: "Term 4", value: "term4" }
    ]
  }),
  methods: {
    getStreamLabel() {
      this.streamLabel = event.target.value;
    },
    openStreamLabelDialog(column) {
      this.streamColumn = column;
      this.assessmentTotal = Number(
        this.$refs["assess-" + column][0].innerHTML
      );
      this.convertedWeight = Number(
        this.$refs["weight-" + column][0].innerHTML
      );
      this.streamLabel = this.$refs["label-" + column][0].value;
      this.applytoOthers = true;
      this.selectedClasses.push(this.selectedClass);
      this.dialog = true;
    },
    selectAllStudents() {
      if (this.selectAll) {
        this.selectedStudents = [];
        this.students.forEach(student => {
          this.selectedStudents.push(student.sid);
        });
      } else {
        this.selectedStudents = [];
      }
    },
    convertToWeight(mark, assessmentLabel) {
      const weight = Number(
        Number(mark) *
          (Number(this.weightings[assessmentLabel].assessment_weight) /
            Number(this.weightings[assessmentLabel].assessment_total))
      ).toFixed(2);
      if (!isNaN(weight)) {
        return weight;
      } else {
        return 0;
      }
    },
    updateField(id, column, assessment) {
      const value = event.target.value;
      axios
        .postDataWithToken(
          "/auth/update-item",
          { table: "assessments", id, column, value },
          this.getAccessToken
        )
        .then(response => {
          const nothing = response;
          let finalMark = 0;
          const assessmentLabels = Object.keys(assessment);

          assessmentLabels.forEach((assessmentLabel, i) => {
            if (
              assessmentLabel.includes("assessment_") &&
              Object.keys(this.weightings).includes(assessmentLabel)
            ) {
              const mark = Number(assessment[assessmentLabel]);
              finalMark += Number(this.convertToWeight(mark, assessmentLabel));
            }
          });
          const data = {
            sid: assessment.sid,
            selectedClass: this.selectedClass,
            subject: this.subject.key,
            reportYear: this.reportYear,
            selectedReportTerm: this.selectedReportTerm,
            finalMark: Math.round(finalMark)
          };
          axios
            .postDataWithToken(
              "/auth/update-marks-schedule",
              data,
              this.getAccessToken
            )
            .then(response => {
              const nothing = response;
            });
        });
    },
    saveWeightings() {
      this.closeDialog();
      this.$store.commit("setLoader", true);
      const data = {
        assessmentLabel: this.streamLabel,
        assessmentColumn: this.streamColumn,
        selectedClasses: this.selectedClasses,
        selectedClass: this.selectedClass,
        subject: this.subject.key,
        reportYear: this.reportYear,
        selectedReportTerm: this.selectedReportTerm,
        assessment: this.streamColumn,
        assessmentTotal: this.assessmentTotal,
        assessmentWeight: this.convertedWeight
      };

      axios
        .postDataWithToken("/auth/update-weightings", data, this.getAccessToken)
        .then(label => {
          this.refreshLabel(label);
        });
    },

    closeDialog() {
      this.applytoOthers = false;
      this.dialog = false;
    },
    updateLabel(column) {
      const value = event.target.value;
      const id = this.labelObj.id;
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/update-assessment-label",
          { id, column, value },
          this.getAccessToken
        )
        .then(label => {
          this.refreshLabel(label);
        });
    },

    viewProfile(item) {
      this.$router.push({ name: "student-profile", params: { sid: item.sid } });
    },

    viewAcademicReportsNow() {
      if (this.reportYear == null && this.selectedReportTerm == null) {
        alert("You Must Select Term And Year, Both Are Required!");
        return false;
      } else {
        axios
          .postDataWithToken(
            "/auth/get-selected-students",
            {
              selectedStudents: this.selectedStudents
            },
            this.getAccessToken
          )
          .then(selStudents => {
            this.$router.push({
              name: "academic-reports",
              params: {
                selectedStudents: selStudents,
                selectedReportTerm: this.selectedReportTerm,
                selectedYear: this.reportYear
              }
            });
          });
      }
    },

    deleteWeighting(assessment) {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/delete-weighting",
          {
            id: assessment.id,
            reportYear: this.reportYear,
            selectedReportTerm: this.selectedReportTerm,
            selectedClass: this.selectedClass,
            subject: this.subject.key
          },
          this.getAccessToken
        )
        .then(label => {
          this.refreshLabel(label);
        });
    },
    refreshLabel(label) {
      this.labelObj = label;
      const labels = Object.entries(label);
      this.headers = [];
      this.labels = [];
      labels.forEach(subject => {
        if (
          subject[0] != "id" &&
          subject[0] != "class" &&
          subject[0] != "subject" &&
          subject[0] != "term" &&
          subject[0] != "year" &&
          subject[0] != "emis"
        ) {
          this.labels.push({ title: subject[1], key: subject[0] });
        }
      });

      this.getWeightings();
    },
    getWeightings() {
      axios
        .postDataWithToken(
          "/auth/get-weightings",
          {
            selectedClass: this.selectedClass,
            subject: this.subject.key,
            reportYear: this.reportYear,
            selectedReportTerm: this.selectedReportTerm
          },
          this.getAccessToken
        )
        .then(weightings => {
          this.weightings = weightings;
          this.headers = [];
          this.headers.unshift(...this.headStart);

          this.labels.forEach(label => {
            if (Object.keys(weightings).includes(label.key)) {
              this.headers.push({ text: label.title, value: label.key });
            }
          });

          this.$store.commit("setLoader", false);
        });
    }
  },
  filters: {
    getAssessmentTotal(assessment) {
      if (assessment && assessment.assessment_total != undefined) {
        return assessment.assessment_total;
      } else {
        return 0;
      }
    },

    getAssessmentWeight(assessment) {
      if (assessment && assessment.assessment_weight != undefined) {
        return assessment.assessment_weight;
      } else {
        return 0;
      }
    }
  }
};
</script>

<style>
</style>